<template>
  <div class="page dashboard-page">
    <el-row :gutter="15" class="wrapper">
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">{{$t('productsCount')}}</p>
          <div class="content">
            <div class="item">
              <p class="name">{{$t('count')}}</p>
              <h1><strong><bean-link keepNode :to="{ name: 'products.index' }">{{productsCount}}</bean-link></strong></h1>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">{{$t('postsCount')}}</p>
          <div class="content">
            <div class="item">
              <p class="name">{{$t('count')}}</p>
              <h1><strong><bean-link keepNode :to="{ name: 'posts.index' }">{{postsCount}}</bean-link></strong></h1>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">{{$t('messagesCount')}}</p>
          <div class="content">
            <div class="item">
              <p class="name">{{$t('count')}}</p>
              <h1><strong><bean-link keepNode :to="{ name: 'messages.index' }">{{messagesCount}}</bean-link></strong></h1>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">{{$t('unreadMessagesCount')}}</p>
          <div class="content">
            <div class="item">
              <p class="name">{{$t('count')}}</p>
              <h1><strong><bean-link keepNode :to="{ name: 'messages.index', query: { is_read_not_eq: true } }">{{unreadMessagesCount}}</bean-link></strong></h1>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class MerchantHome extends Vue {
    productsCount = 0
    postsCount = 0
    messagesCount = 0
    unreadMessagesCount = 0

    async mounted() {
      const [products, posts, messages, unreadMessages] = await Promise.all([
        this.$request.get('/products?per_page=1'),
        this.$request.get('/posts?per_page=1'),
        this.$request.get('/messages?per_page=1'),
        this.$request.get('/messages?is_read_not_eq=true&per_page=1')
      ]);

      this.productsCount = products.pagination.total
      this.postsCount = posts.pagination.total
      this.messagesCount = messages.pagination.total
      this.unreadMessagesCount = unreadMessages.pagination.total
    }
  }
</script>
